import React, { useEffect, useState } from "react";
import axios from "axios";
import "../SellerMarketingReferral/SellerMarketingReferral.css";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerMarketingReferral() {
  const [marketingData, setMarketingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");
console.log("SENT TOKEN:", token);

 const fetchMarketingData = async () => {
  if (!token) return;

  try {
    setLoading(true);

    // أولاً نضمن إن فيه record
    await axios.get(
      `${BaseUrl}${SellerServicesUrl.SendMarketingRequest}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const res = await axios.get(
      `${BaseUrl}${SellerServicesUrl.GetMarketingData}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setMarketingData(res?.data?.data || null);
  } catch (err) {
    console.log(err);
    setError("حدث خطأ أثناء تحميل بيانات التسويق");
  } finally {
    setLoading(false);
  }
};

  if (loading) {
    return (
      <div className="container text-center mt-5 pt-5">
        <p>جاري تحميل بيانات التسويق...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container text-center mt-5 pt-5 text-danger">
        <p>{error}</p>
      </div>
    );
  }

  if (!marketingData) {
    return (
      <div className="container text-center mt-5 pt-5">
        <p>لا توجد بيانات تسويق حالياً</p>
      </div>
    );
  }

  return (
    <div className="container marketing-referral-page mt-5 pt-5 mb-5 pb-5">
      <h2 className="page-title mb-4">برنامج التسويق بالعمولة</h2>

      <div className="marketing-card">
        <h4>كود الإحالة الخاص بك</h4>
        <p className="referral-code">
          {marketingData.code || "لا يوجد كود حالياً"}
        </p>
      </div>

      <div className="marketing-stats mt-4">
        <div className="stat-box">
          <h5>عدد المستخدمين</h5>
          <p>{marketingData.count || 0}</p>
        </div>

        <div className="stat-box">
          <h5>إجمالي الأرباح</h5>
          <p>{marketingData.amount || 0} ر.س</p>
        </div>
      </div>
    </div>
  );
}
